// MF-554 — Board Builder (Analytics › Board Builder): the school's Boards, the Chart Library and the editor.
// Gated by the BoardsBuilder module (license `boards`); the backend enforces the same.
import { Routes, Route } from 'react-router-dom'
import BoardsList from './BoardsList'
import BoardEditor from './BoardEditor'
import LibraryPage from '../Library/LibraryPage'

const BoardBuilder = () => (
  <Routes>
    <Route index element={<BoardsList />} />
    <Route path='library' element={<LibraryPage />} />
    <Route path=':boardId' element={<BoardEditor />} />
  </Routes>
)

export default BoardBuilder
